import { api } from 'services/api'
import { take, fork, select, put } from 'redux-saga/effects'
import { FilterActions, selectCountryFilter, selectTeamFilter, setCountryFilter, setTeamFilter } from 'state/filter'
import { getProfileDetail, selectIsInternalUser } from 'state/profile'
import _ from 'lodash'
import { State, selectCampaign } from 'state'
import { STATE_KEYS } from 'state/requests'
import { REHYDRATE } from 'redux-persist/lib/constants'

// This function will set the API header on load.
export function* handleSetApiHeader(payload: State): any {
    if (!payload) return
    // Check for the redux-persist settings to see the list of persisted state
    const { filter } = payload
    if (filter && filter.team) {
        api.setHeader('Team', filter.team)
    }
}

export function* watchSetApiHeader(): any {
    while (true) {
        const action = yield take(REHYDRATE)
        yield fork(handleSetApiHeader, action.payload)
    }
}

export function* handleSetTeamFilter(): any {
    const teamFilter = yield select(selectTeamFilter)
    try {
        const currentTeamFilter = api.headers['Team']
        if (teamFilter !== currentTeamFilter) {
            api.setHeader('Team', teamFilter)
            yield put(getProfileDetail({ stateKey: STATE_KEYS.SkipLoading }))
        }
    } catch {}
}

export function* watchSetTeamFilter(): any {
    while (true) {
        yield take(FilterActions.FILTER_TEAM)
        yield fork(handleSetTeamFilter)
    }
}

export function* handleSetTeamCountryByCampaign(campaignUuid: string): any {
    const campaign = yield select(selectCampaign(campaignUuid))
    const currentTeamFilter = yield select(selectTeamFilter)
    const currentCountryFilter = yield select(selectCountryFilter)
    const isInternalUser = yield select(selectIsInternalUser)

    if (isInternalUser) {
        if (!_.isEmpty(currentCountryFilter) && campaign?.country !== currentCountryFilter) {
            yield put(setCountryFilter(''))
        }
    } else {
        if (!_.isEmpty(currentTeamFilter) && campaign?.brand.team.uuid !== currentTeamFilter) {
            yield put(setTeamFilter(campaign?.brand.team.uuid))
        }
    }
}

export function* watchSetTeamCountryByCampaign(): any {
    while (true) {
        const action = yield take(FilterActions.SET_TEAM_COUNTRY_BY_CAMPAIGN)
        yield fork(handleSetTeamCountryByCampaign, action.payload)
    }
}
